import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scene-settings-information-popover',
  templateUrl: './scene-settings-information-popover.component.html',
  styleUrls: ['./scene-settings-information-popover.component.scss'],
})
export class SceneSettingsInformationPopoverComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
